const NCALAYER_WSS_URL = "wss://127.0.0.1:13579/";
const NCALAYER_DEEP_LINK = "kz.gov.pki.knca://";
const CHECK_TIMEOUT_MS = 2000;
const POLL_INTERVAL_MS = 1500;
const DEFAULT_WAIT_TIMEOUT_MS = 15000;

class NCALayerService {
  _pollingId = null;
  _settled = false;

  async checkConnection() {
    return new Promise((resolve) => {
      const ws = new WebSocket(NCALAYER_WSS_URL);
      const timeoutId = setTimeout(() => {
        ws.close();
        resolve(false);
      }, CHECK_TIMEOUT_MS);

      ws.onopen = () => {
        clearTimeout(timeoutId);
        ws.close();
        resolve(true);
      };

      ws.onerror = () => {
        clearTimeout(timeoutId);
        ws.close();
        resolve(false);
      };
    });
  }

  openNCALayer() {
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = NCALAYER_DEEP_LINK;
    document.body.appendChild(iframe);
    setTimeout(() => document.body.removeChild(iframe), 500);
  }

  waitForConnection({ timeout = DEFAULT_WAIT_TIMEOUT_MS } = {}) {
    if (this._pollingId !== null) {
      return Promise.reject(new Error("Polling already in progress"));
    }

    this._settled = false;

    return new Promise((resolve, reject) => {
      const startTime = Date.now();

      const settle = (fn) => {
        if (this._settled) return;
        this._settled = true;
        this._clearPolling();
        fn();
      };

      const check = async () => {
        if (this._settled) return;

        if (Date.now() - startTime >= timeout) {
          settle(() =>
            reject(new Error("NCALayer не был запущен в отведённое время"))
          );
          return;
        }

        const available = await this.checkConnection();
        if (available) {
          settle(() => resolve());
        }
      };

      check();
      this._pollingId = setInterval(check, POLL_INTERVAL_MS);
    });
  }

  stopChecking() {
    this._settled = true;
    this._clearPolling();
  }

  _clearPolling() {
    if (this._pollingId !== null) {
      clearInterval(this._pollingId);
      this._pollingId = null;
    }
  }
}

export const ncaLayerService = new NCALayerService();
